import { RiErrorWarningLine } from 'react-icons/ri';
import styled from 'styled-components';
import { layout } from 'styled-system';

type Props = {
  size: number;
};

export const StyledErrorIcon = styled(RiErrorWarningLine)<Props>(layout, (props) => ({
  width: props.size,
  height: props.size,
}));
